<template>
  <div>
    <div v-if="tipoIdPaiLocale === 7">
      <v-textarea
        v-model="nodeDataLocale.botaoOpcaoTitle"
        label="Título do botão *"
        placeholder="Digite uma Mensagem"
        outlined
        auto-grow
        rows="1"
        row-height="15"
        class="mt-2"
        :rules="[validators.required, (v) => (!!v && v.length <= 60) || 'Máximo de 60 caracteres']"
        @change="nodeConfig"
      />
    </div>

    <div v-else-if="tipoIdPaiLocale === 8">
      <v-textarea
        v-model="nodeDataLocale.listaOpcaoTitle"
        label="Título do botão *"
        placeholder="Digite uma Mensagem"
        outlined
        auto-grow
        rows="1"
        row-height="15"
        class="mt-2"
        :rules="[validators.required, (v) => (!!v && v.length <= 24) || 'Máximo de 24 caracteres']"
        @change="nodeConfig"
      />

      <v-textarea
        v-model="nodeDataLocale.listaOpcaoDescription"
        label="Descrição do botão"
        placeholder="Digite uma Mensagem"
        outlined
        auto-grow
        rows="1"
        row-height="15"
        class="mt-2"
        :rules="[(v) => (!!v && v.length <= 72) || 'Máximo de 72 caracteres']"
        @change="nodeConfig"
      />
    </div>
  </div>
</template>

<script>
import { inject, ref, watch } from '@vue/composition-api'
import { required, select } from '@/@core/utils/validation'
import NodeChatBotModel from '@/models/entities/chat-bot/NodeChatBotModel'

export default {

  setup(props, { emit }) {
    function nodeConfig() {
      //   console.log(props.nodeData)
      emit('node-config')
    }

    const nodeDataLocale = ref(new NodeChatBotModel())
    const nodeData = inject('nodeData')
    watch(() => nodeData.value, value => { nodeDataLocale.value = value }, { immediate: true, deep: true })

    const tipoIdPaiLocale = ref(0)
    const tipoIdPai = inject('nodeTipoIdPai')
    watch(() => tipoIdPai.value, value => {
      tipoIdPaiLocale.value = value
    }, { immediate: true, deep: true })

    return {
      nodeConfig,
      nodeDataLocale,
      tipoIdPaiLocale,
      validators: {
        required,
        select,
      },
    }
  },
}
</script>
